import React, { useEffect } from "react";
import { IPaymentFields, ISettings } from "../Models";
import { useFormContext } from "react-hook-form";
import { Form } from "react-bootstrap";
import { currentLanguage } from "../../Shared/Reservation/StringResources";

export const Payment = (props: { settings: ISettings, paymentCountry?: string }) => {

	const { register, watch, setValue } = useFormContext<IPaymentFields>();
	const paymentMethod = watch("paymentMethod");

	const showCard = props.settings.adyenMethods?.includes("scheme");
	const showPaypal = props.settings.adyenMethods?.includes("paypal");
	const showKlarna = props.settings.adyenMethods?.includes("klarna") && currentLanguage() === "sv";
	const showBillie = props.settings.adyenMethods?.includes("klarna_b2b") && currentLanguage() === "sv";
	const showSwish = props.settings.adyenMethods?.includes("swish");
	const klarnaDisabled = (props.paymentCountry && props.paymentCountry !== "SE");
	const showApplePay = props.settings.adyenMethods?.includes("applepay") && /Safari/.test(window.navigator.userAgent);

	useEffect(() => {
		if (klarnaDisabled && ["adyen.klarna", "adyen.klarna_b2b"].includes(paymentMethod))
			setValue("paymentMethod", undefined);
	}, [klarnaDisabled]);


	return <div>

		{ props.settings.allowFakePayments &&
			<Form.Check custom type="radio" label="Fejkbetalning" id="paymentMethod-fake"
				className="payment-type-fake" value="fake" name="paymentMethod" {...register("paymentMethod", { required: true }) }></Form.Check> }

		{ showSwish && <Form.Check custom type="radio" label={getPaymentIcon("swish")} id="paymentMethod-swish"
				className="payment-type-swish" value="adyen.swish" name="paymentMethod" {...register("paymentMethod", { required: true }) }></Form.Check> }
		{ showCard &&
			<Form.Check custom type="radio" label={getPaymentIcon("adyen.scheme")} id="paymentMethod-adyen-scheme"
					className="payment-type-adyen-scheme" value="adyen.scheme" name="paymentMethod" {...register("paymentMethod", { required: true }) }></Form.Check> }
		{ showPaypal &&
			<Form.Check custom type="radio" label={getPaymentIcon("adyen.paypal")} id="paymentMethod-adyen-paypal"
					className="payment-type-adyen-paypal" value="adyen.paypal" name="paymentMethod" {...register("paymentMethod", { required: true }) }></Form.Check> }
		{ showKlarna &&
			<Form.Check custom type="radio" label={getPaymentIcon("adyen.klarna")} id="paymentMethod-adyen-klarna" disabled={klarnaDisabled}
					className="payment-type-adyen-klarna" value="adyen.klarna" name="paymentMethod" {...register("paymentMethod", { required: true }) }></Form.Check> }
		{ showBillie &&
			<Form.Check custom type="radio" label={getPaymentIcon("adyen.klarna_b2b")} id="paymentMethod-adyen-klarna-b2b" disabled={klarnaDisabled}
					className="payment-type-adyen-klarna" value="adyen.klarna_b2b" name="paymentMethod" {...register("paymentMethod", { required: true }) }></Form.Check> }
		{ showApplePay &&
			<Form.Check custom type="radio" label={getPaymentIcon("adyen.applepay")} id="paymentMethod-adyen-applepay"
					className="payment-type-adyen-applepay" value="adyen.applepay" name="paymentMethod" {...register("paymentMethod", { required: true }) }></Form.Check> }
	</div>

};


function getPaymentIcon(method: string) {

	switch (method) {
		case "swish":
			return <img src="/img/icons/swish.svg" alt="Swish" title="Swish" />;
		case "adyen":
		case "adyen.scheme":
			return <><img src="/img/icons/visa.svg" alt="Visa" /><img src="/img/icons/mastercard.svg" alt="MasterCard" /></>;
		case "adyen.paypal":
			return <><img src="/img/icons/paypal.svg" alt="PayPal" title="PayPal" /></>;
		case "adyen.klarna":
			return <><img src="/img/icons/klarna.svg" alt="Klarna" title="Klarna - Betala sen" /></>;
		case "adyen.applepay":
			return <><img src="/img/icons/applepay.svg" alt="Klarna" title="Apple Pay" /></>;
		case "adyen.klarna_b2b":
			return <><img src="/img/icons/billie-black.svg" alt="Billie" title="Faktura för företag" /> Faktura för företag</>;
		case "fake":
			return <>Fejkbetalning (för test)</>;
		default:
			return null;
	}
}